import {
  Box,
  Table
} from '@chakra-ui/react';

import { formatNumber } from "../../../store/helpers";
import LineGraph from "../../LineGraph";
import TimeOfDayChart from "../../TimeOfDayChart";
import { useSelector } from "react-redux";
import { normalizeArrivalRatesPerHourReport } from "../../../store/arrivalRates";
import { ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";

const renderCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName || row.branchName;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "average") return formatNumber(row.average);
  if (columnId === "min") return formatNumber(row.min);
  if (columnId === "max") return formatNumber(row.max);
  return null;
};

const ArrivalRatesPerHourTable = ({ data: rawData, index, renderConfig }) => {
  const { hoursPerDay } = useSelector((store) => store.defaultReducer);
  const data = normalizeArrivalRatesPerHourReport(rawData, hoursPerDay);
  const { total, average, min, max, branchName, chart, timeOfDayChart } = data;

  if (!renderConfig?.charts?.enabled) {
    const row = { ...data, scopeName: branchName || "Entire Organization" };
    return (
      <Box className="reportTableContainer arrivalRatesSummaryBlock">
        <ConfiguredReportTable
          columns={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
          rows={[row]}
          renderConfig={renderConfig}
          renderCell={renderCell}
        />
      </Box>
    );
  }

  return (
    <>
      <Box>
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Total Visitors</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader>Max</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(total)}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(average)}</Table.Cell>
              <Table.Cell>{formatNumber(min)}</Table.Cell>
              <Table.Cell>{formatNumber(max)}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell colSpan={5}>
                <Box mt="20px" mb="20px">
                  <LineGraph
                    chart={chart}
                    lineName={"Avg / Hour"}
                    title={`${branchName} Arrival Rates Per Hour, Day by Day Comparison`}
                  />
                  <Box mt={10}>
                    <TimeOfDayChart
                      {...timeOfDayChart}
                      title={"Time of Day Chart"}
                    />
                  </Box>
                </Box>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      </Box>
    </>
  );
};

export default ArrivalRatesPerHourTable;
